module.exports = __webpack_public_path__ + "img/transportation.68d3869e.png";